import axios from 'axios';

const baseUrl = process.env.REACT_APP_QCX_API_BASE_URL! + '/followup/report/kpi-importacao';

export interface KpiImportacaoFiltros {
  tenantIds: string[];
  clientIds: string[];
  dataAberturaRange: string;
  dataRegistroRange: string;
  dataDesembaracoRange: string;
  dataFaturamentoRange: string;
}

export const generateKpiImportacaoReport = async (
  token: string,
  unidadeId: string,
  filtros: KpiImportacaoFiltros
): Promise<string | null> => {
  const params = new URLSearchParams();
  params.set('tenantId', filtros.tenantIds.join(','));

  if (filtros.clientIds.length > 0) {
    params.set('clientesId', filtros.clientIds.join(','));
  }

  const periodos: [string, string][] = [
    ['dataAberturaRange', filtros.dataAberturaRange],
    ['dataRegistroRange', filtros.dataRegistroRange],
    ['dataDesembaracoRange', filtros.dataDesembaracoRange],
    ['dataFaturamentoRange', filtros.dataFaturamentoRange],
  ];
  periodos
    .filter(([, valor]) => valor !== ';')
    .forEach(([nome, valor]) => params.set(nome, valor));

  try {
    const response = await axios.get(`${baseUrl}?${params.toString()}`, {
      headers: {
        Authorization: `Bearer ${token}`,
        quickcomexTenant: unidadeId,
      },
      responseType: 'blob',
      validateStatus: () => true,
    });

    if (response.status === 200) {
      const dataAtual = new Date().toISOString().slice(0, 10);
      const file = new File([response.data], `KPI IMPORTAÇÃO - ${dataAtual}.xlsx`, {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });
      const url = window.URL.createObjectURL(file);
      const a = document.createElement('a');
      a.href = url;
      a.download = file.name;
      a.click();
      window.URL.revokeObjectURL(url);
      return null;
    }

    const errText = await response.data.text();
    return errText || 'Erro ao gerar o relatório.';
  } catch (networkError) {
    return 'Não foi possível conectar ao servidor para gerar o relatório.';
  }
};
